import { createContext } from "react";
import type {
  AuthWrapperCustomEvent,
  AuthWrapperIsB6AuthStoredMessage,
  AuthWrapperIsCreditProfileUserMessage,
  AuthWrapperIsTokenStoredMessage,
  AuthWrapperProfileMessage,
  AuthWrapperTokenMessage,
} from "@jetblue/auth-wrapper";

export type AuthContextProperties = {
  IS_B6AUTH_STORED?: AuthWrapperIsB6AuthStoredMessage;
  IS_CREDIT_PROFILE_USER?: AuthWrapperIsCreditProfileUserMessage;
  IS_TOKEN_STORED?: AuthWrapperIsTokenStoredMessage;
  PROFILE?: AuthWrapperProfileMessage;
  TOKEN?: AuthWrapperTokenMessage;
};
export const DEFAULT_AUTH_CONTEXT: AuthContextProperties = {};
export const AuthContext =
  createContext<AuthContextProperties>(DEFAULT_AUTH_CONTEXT);
export const authReducer = (
  state: AuthContextProperties,
  detail: AuthWrapperCustomEvent["detail"],
): AuthContextProperties => {
  switch (detail.action) {
    case "IS_B6AUTH_STORED":
    case "IS_CREDIT_PROFILE_USER":
    case "TOKEN":
    case "IS_TOKEN_STORED":
    case "PROFILE": {
      return { ...state, [detail.action]: detail.value };
    }
    case "LOGOUT_STATUS": {
      if (detail.value === "Completed") {
        return { ...state, PROFILE: undefined };
      }

      return state;
    }
    default: {
      return state;
    }
  }
};
